module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_15.98d844bb.jpg";